import { initShaderProgram } from "../../../../SharedGL/Shader";

export class PairingShader {
  // Vertex shader program
  private readonly vsSource = `
    attribute vec4 aVertexPosition;
    attribute vec4 aVertexColor;

    uniform mat4 uModelViewMatrix;
    uniform mat4 uProjectionMatrix;
    uniform highp float uYPos;

    varying lowp vec4 vColor;

    void main(void) {
      highp vec4 position = vec4( aVertexPosition.x, aVertexPosition.y + uYPos, aVertexPosition.zw);
      gl_Position = uProjectionMatrix * uModelViewMatrix * position;
      vColor = aVertexColor;
    }
  `;
  // Fragment shader program
  private readonly fsSource = `
    varying lowp vec4 vColor;

    void main(void) {
      gl_FragColor = vColor;
    }
  `;

  public readonly shaderProgram: WebGLProgram;
  constructor(gl: WebGLRenderingContext) {
    this.shaderProgram = initShaderProgram(gl, this.vsSource, this.fsSource);
  }
}
